import React, { useState, useRef, useEffect } from "react";

import { TopNavBarOneContainer } from "./topNavBarOne.styled";

import bellIcon from "../../assets/svgIcons/bell-icon.svg";
import downArrow from "../../assets/svgIcons/chevron-down.svg";
import avatarImg from "../../assets/images/avatar-2.png";
import logout from "../../assets/icons/logout.png";
import RenderIf from "../renderIf";
import { useDispatch, useSelector } from "react-redux";
import { SagaActions } from "../../redux/actionTypes";
import { RootState } from "../../redux/store";
import { useNavigate } from "react-router-dom";
import { ROUTE_NAMES } from "../../constants/routeNames";
import { IoIosLogOut } from "react-icons/io";
import cepIcon from "../../assets/svgIcons/cep-icon.svg";
import { CgProfile } from "react-icons/cg";
import AES from "crypto-js/aes";

const TopNavBarOne = () => {
  const navigate = useNavigate();
  const toEAdminBtn = useRef(null);
  const [showMenu, setshowMenu] = useState(false);
  const popupRef = useRef<any>();
  const Dispatch = useDispatch();
  const { profile } = useSelector((_state: RootState) => _state);
  const _profile = profile?.data || null;

  const roleID = localStorage.getItem("@role");
  const _isCepAdmin = 102 == Number(roleID);

  const _onPress = ({ key, data }: { key: string; data?: any }) => {
    const fun: any = {
      null: () => {},
      logout: () => {},
      signout: () => {},
      bell: () => {},
      toggleMenu: () => setshowMenu(true),
      // toEAdmin: async () => {
      //   try {
      //     const tokenExpiresOn = localStorage.getItem("tokenExpiresOn");
      //     const refreshToken = localStorage.getItem("refreshToken");
      //     const tokenExpireDuration = localStorage.getItem(
      //       "tokenExpireDuration"
      //     );
      //     const roleIs = localStorage.getItem("@role");
      //     const userId = localStorage.getItem("userID");
      //     const encriptdataIs = AES.encrypt(
      //       JSON.stringify({
      //         tokenExpiresOn,
      //         tokenExpireDuration,
      //         refreshToken,
      //         roleIs,
      //         userId,
      //       }),
      //       "vmzCareerX"
      //     ).toString();
      //     const _encriptdataIs = encriptdataIs.replaceAll("/", "$");
      //     console.log(encriptdataIs.replaceAll("/", "$"), "encrypted token");

      //     window.location.href =
      //       "http://localhost:3000/from-padmin/loading/" + _encriptdataIs;
      //   } catch (error) {}
      // },
    };
    fun[key](data);
  };

  useEffect(() => {
    const handleOutsideClick = (event: any) => {
      if (popupRef.current && !popupRef.current?.contains(event.target)) {
        setshowMenu(false);
      }
    };

    // Add event listener when the component mounts
    document.addEventListener("mousedown", handleOutsideClick);

    // Remove event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  const logoutHandler = () => {
    localStorage.setItem("token", "");
    navigate(`${ROUTE_NAMES.Initial}`);
  };

  useEffect(() => {
    Dispatch({ type: SagaActions.FETCH_PROFILE });
  }, []);

  return (
    <TopNavBarOneContainer>
      {/* <button className="icon-btn" onClick={() => _onPress({ key: "bell" })}>
        <img src={bellIcon} />
      </button> */}
      {/* <button className="icon-btn" onClick={() => _onPress({ key: "logout" })}>
        <img src={avatarImg} />
      </button> */}
      <div className="dropdown_menu_container">
        <RenderIf isShow={!showMenu}>
          <button
            className="icon-btn"
            onClick={() => _onPress({ key: "toggleMenu" })}
          >
            <img src={downArrow} />
          </button>
        </RenderIf>
        <RenderIf isShow={!!showMenu}>
          <button className="icon-btn" onClick={() => {}}>
            <img src={downArrow} style={{ transform: `rotate(180deg)` }} />
          </button>
        </RenderIf>
        <div
          ref={popupRef}
          className={`menu_box ${
            showMenu && "show_menu"
          } px-4 py-3 me-2 border rounded-2`}
        >
          {/* {_isCepAdmin && (
            <button
              className="mb-2 justify-content-start d-flex px-1"
              onClick={() => _onPress({ key: "toEAdmin" })}
              style={{ fontSize: 15, fontWeight: 500 }}
            >
              <img src={cepIcon} width={18} className="me-2" />
              EAdmin View
            </button>
          )} */}
          {/* {!_isCepAdmin && (
            <> */}
              <div
                className="px-1 pt-1 mb-2"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <CgProfile size={18} />
                {/* <h5
                style={{ fontSize: 15, fontWeight: 500 }}
              >{`${_profile?.firstName} ${_profile?.lastName}`}</h5> */}
                <label
                  style={{ fontSize: 15, fontWeight: 500 }}
                  className="ms-1 p-1"
                >
                  {`${_profile?.firstName} ${_profile?.lastName}`}
                </label>
              </div>
            {/* </>
          )} */}
          {/* {!_isCepAdmin && <div className="border"></div>} */}
          <div className="border"></div>

          <div className="p-1" onClick={logoutHandler}>
            {/* <img src={logout} /> */}
            <IoIosLogOut size={19} />
            {/* <button className="sm-text p-1">Logout</button> */}
            <label
              style={{ fontSize: 15, fontWeight: 500 }}
              className="ms-1 p-1"
            >
              Logout
            </label>
          </div>
        </div>
      </div>
    </TopNavBarOneContainer>
  );
};

export default TopNavBarOne;
